import React, { useEffect, useState } from "react";
import { Box, Avatar, Typography,Button } from "@mui/material";
import LinkIcon from "../../assets/Link.png"

import {  IconButton} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";

import DaalchiniWallet from '../../assets/Dp.png'
import nextArrow from '../../assets/nextArrow.png'
import Bp from '../../assets/BP.png'
import Tick from '../../assets/tick.png'
import Paytm from '../../assets/Paytm.png'
import card from '../../assets/card.png'
import plxlogo from '../../assets/plx-logo.svg'
import wallet from '../../assets/wallet.png'
import { Link, useLocation } from "react-router-dom";
import './paymentoption.css'
import Error from '../../assets/Error.png'
import { useNavigate } from "react-router-dom";
import WaitingLoder from "../../Loader/component";
import PaymentSection from "./1";
import SodexoPayment from "./2";



const image_base_url = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/";
const defaultPgId=localStorage.getItem("defaultPgId")
function PaymentOptions({paymentOptionsList,SetpaymentGatewayId,props,SodexoLink,LinkSodexo,loader,setSodexoUnlinkModal}) {
  const navigate = useNavigate()
    const location = useLocation()
    const params = new URLSearchParams(location.search);


  const route = params.get("route");
  const gotoHistory = () => {
    
    navigate('/dphistory')
  }
  console.log("route",route )
  const defaultPgName = localStorage.getItem('defaultPgName');
  //console.log("props PaymentOptions", props && props.paymentOptionsList );

  const LinkBpFun = (e) => {
   
    navigate('/link/bp')


  }
useEffect(()=>{
  window.scrollTo(0, 0); 
},[])
 
const handleBack=()=>{
  if(route){
    
  navigate(`/${route}`)
  }
  else{
     navigate(`/`)
  }
}


const OtherUpi = (  ) => {
    //console.log("paymentOptionsList?.[1]?.pgId-----------",paymentOptionsList?.[1]?.pgId)
  return (
    <div>    <h1 style={{paddingBottom:"10px",color:"#718198", fontFamily:"roboto"}}>UPI</h1>
    <Box display="flex" justifyContent="flex-start">
  
      <Box
        onClick={(e) =>
          SetpaymentGatewayId(
            e,
           2,
            paymentOptionsList?.[1]?.pgName,
            "R_UPI"
          )
        }
        sx={{
          textAlign: "center",
          cursor: "pointer",
          p: 1.5,
          borderRadius: 2,
          boxShadow:
         paymentOptionsList?.[1]?.pgId==defaultPgId&&defaultPgName=="R_UPI"
              ? "1px 1px 10.4px 1px rgba(107, 198, 87, 0.7)"
              : 3, // MUI predefined shadow
          background: "white",
        /*   border: paymentOptionsList?.[1]?.pgId==defaultPgId&&defaultPgName=="R_UPI"
              ? "1px solid green"
              : "1px solid transparent", */
          "&:hover": {
            backgroundColor: "#f5f5f5",
            transform: "scale(1.03)",
            transition: "0.2s",
            boxShadow: 6, // shadow on hover
          },
        }}
      >
        <Avatar
          src="https://aniportalimages.s3.amazonaws.com/media/details/ANI-20221205070213.jpg"
          alt="UPI (Other Apps)"
          sx={{
            width: 78,
            height: 78,
            borderRadius: "64px",
            mx: "auto",
          }}
        />

        <Typography
          variant="body2"
          sx={{ fontSize: "13px", mt: 1, fontWeight: 500 }}
        >
          UPI (Other Apps)
        </Typography>
      </Box>
    </Box>
    </div>
  );
};



const PaytmOption = () => {
  const paytm = paymentOptionsList[0];

  if (!paytm) return null;

  return (
    <Box sx={{ mb: 1, width: "100%" }}>
      {/* Active Paytm */}
      {paytm.active ? (
        <Box
          onClick={(e) => SetpaymentGatewayId(e, paytm.pgId, paytm.pgName,"PAYYM_UPI")}
          sx={{
           
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 1,
            borderRadius: defaultPgName === "PAYTM" ? "15px" : "15px",
            boxShadow:
              defaultPgName === "PAYTM"
                ? "0px 4px 10.4px 1px rgba(0, 177, 119, 0.23)"
                : "none",
            border: defaultPgName === "PAYTM" ? "1px solid rgba(0,177,119,0.5)" : "none",
            cursor: "pointer",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Avatar
              src={Paytm}
              sx={{ width: 32, height: 27, borderRadius: 0 }}
            />
            <Box sx={{ ml: 1 }}>
              <Typography sx={{ fontSize: 16, fontWeight: 500, color: "#333F4E" }}>
                Paytm
              </Typography>
              <Typography sx={{ fontSize: 13, color: "#718198" }}>
                Balance ₹{paytm.balance}
              </Typography>
            </Box>
          </Box>
          <Avatar src={nextArrow} sx={{ width: 10, height: 16, bgcolor: "transparent" }} />
        </Box>
      ) : (
        // Inactive / Not linked / REAUTHORIZE
        <Box sx={{ width: "100%", mb: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 1,
              borderRadius: "15px",
            
               
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Avatar src={Paytm} sx={{ width: 32, height: 27, borderRadius: 0 }} />
              <Box sx={{ ml: 1 }}>
                <Typography sx={{ fontSize: 16, fontWeight: 500, color: "#333F4E" }}>
                  Paytm
                </Typography>
              </Box>
            </Box>

            {/* Link / Reauthorize Button */}
            {(!paytm.reason || paytm.reason !== "REAUTHORIZE") && (
              <Link to="/paytm">
                <Button sx={{ color: "#00B177" }}>Link</Button>
              </Link>
            )}
            {paytm.reason === "REAUTHORIZE" && (
              <Link to="/paytm">
                <Button
                  sx={{
                    color: "#FF8989",
                    fontSize: 12,
                    fontWeight: 500,
                    backgroundColor: "rgba(177,0,0,0.05)",
                        border: "1px solid"
                  }}
                >
                  Reauthorize
                </Button>
              </Link>
            )}
          </Box>

          {/* Reauthorize Message */}
          {paytm.reason === "REAUTHORIZE" && (
            <Box sx={{ p: 1.5 }}>
              <Box
                sx={{
                  borderRadius: 1,
                  border: "1px solid #FDD",
                  background: "rgba(255, 0, 0, 0.05)",
                 padding:"15px",
                  display: "flex",
                  alignItems: "center",
                 
                }}
              >
                <Avatar src={Error} sx={{ width: 23, height: 23, ml: 0.5 }} />
                <Box sx={{ ml: 1 }}>
                  <Typography sx={{ fontSize: 16, fontWeight: 500, color: "#333F4E" }}>
                    Reauthorize your account
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#718198", mt: 0.5 }}>
                    Your payment profile has expired.<br />
                    Please reauthorize to continue using your<br />
                    payment profile.
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};




const PaymentOptions = () => {
  
  return (
    <Box
      sx={{
        mt: "4%",
        mx: 2,
        mb: 1,
        borderRadius: 2,
        backgroundColor: "#FFF",
        boxShadow: "0px 4px 10px 0px rgba(56, 79, 111, 0.12)",
      }}
    >
{loader&&<WaitingLoder/>}
<PaymentSection
  route={route}
  paymentOptionsList={paymentOptionsList}
  defaultPgName={defaultPgName}
  SetpaymentGatewayId={SetpaymentGatewayId}
  gotoHistory={gotoHistory}
  LinkBpFun={LinkBpFun}
  DaalchiniWallet={DaalchiniWallet}
  Bp={Bp}
  nextArrow={nextArrow}
/>



    </Box>
  );
};



const OtherPaymentOptions = () => {
  const rCard = paymentOptionsList[1]; // Debit/Credit Cards
  const rWallet = paymentOptionsList[1]; // Wallets (assuming same index but different type)
  const sodexo = paymentOptionsList[5]; // Pluxee/Sodexo

  return (
    <Box sx={{ mt: "4%", mx: 2, mb: 1, borderRadius: 2, backgroundColor: "#FFF", boxShadow: "0px 4px 10px 0px rgba(56, 79, 111, 0.12)", }}>
      
      {/* Debit/Credit Cards */}
      <Box
        onClick={(e) => SetpaymentGatewayId(e, rCard?.pgId, rCard?.pgName, "R_CARD")}
        sx={{
         
          mb: 1,
          p: 1,
          borderRadius: defaultPgName == "R_CARD" ? "15px" : "15px",
          boxShadow: defaultPgName == "R_CARD" ? "0px 4px 10.4px 1px rgba(0, 177, 119, 0.23)" : "none",
          border: defaultPgName =="R_CARD" ? "1px solid rgba(0, 177, 119, 0.5)" : "none",
          cursor: "pointer",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Avatar src={card} sx={{ width: 32, height: 27, borderRadius: 0 }} />
            <Box sx={{ ml: 1 }}>
              <Typography sx={{ fontSize: 16, fontWeight: 500, color: "#333F4E" }}>Debit/Credit Cards</Typography>
              <Typography sx={{ fontSize: 13, color: "#718198" }}>Visa, MasterCard, Rupay & more...</Typography>
            </Box>
          </Box>
          <Avatar src={nextArrow} sx={{ width: 10, height: 16, bgcolor: "transparent" }} />
        </Box>
      </Box>

      {/* Wallets */}
      <Box
        onClick={(e) => SetpaymentGatewayId(e, rWallet?.pgId, rWallet?.pgName, "R_WALLET")}
        sx={{
          
          mb: 1,
          p: 1,
          borderRadius: defaultPgName === "R_WALLET" ? "15px" : "15px",
          boxShadow: defaultPgName === "R_WALLET" ? "0px 4px 10.4px 1px rgba(0, 177, 119, 0.23)" : "none",
          border: defaultPgName === "R_WALLET" ? " 1px solid rgba(0, 177, 119, 0.5)" : "none",

          cursor: "pointer",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Avatar src={wallet} sx={{ width: 32, height: 27, borderRadius: 0 }} />
            <Box sx={{ ml: 1 }}>
              <Typography sx={{ fontSize: 16, fontWeight: 500, color: "#333F4E" }}>Wallets</Typography>
              <Typography sx={{ fontSize: 13, color: "#718198" }}>AmazonPay, PhonePe & more...</Typography>
            </Box>
          </Box>
          <Avatar src={nextArrow} sx={{ width: 10, height: 16, bgcolor: "transparent" }} />
        </Box>
      </Box>

      {/* Pluxee/Sodexo */}
<SodexoPayment
  route={route}
  sodexo={sodexo}
  defaultPgName={defaultPgName}
  SetpaymentGatewayId={SetpaymentGatewayId}
  setSodexoUnlinkModal={setSodexoUnlinkModal}
  SodexoLink={SodexoLink}
  LinkSodexo={LinkSodexo}
  plxlogo={plxlogo}
/>




    </Box>
  );
};



const PaymentHeader = () => {
  return (
    <Box display="flex" alignItems="center" p={2} sx={{ background: "#fae14b" ,position: "fixed",width:"100%",zIndex: "999"}}>
      <IconButton onClick={handleBack}>
        <ArrowBackIcon />
      </IconButton>
      <Typography variant="h6" sx={{ fontWeight: 500, ml: 1 }}>
        Payment Settings
      </Typography>
    </Box>
  );
};





  return (
    <>
   
<PaymentHeader/>
      <div>

        <div>
       
   {!["dphistory", "taghistory"].includes(
  route?.replace(/^\/|\/$/g, "").split("/")[0]
) &&
  props?.sodexoUnlinkModal && (
    <div className="modalDeactive">
      <div className="modal-content-bpHistory" style={{ height: "180px" }}>
        <img
          src={LinkIcon}
          style={{ marginLeft: "33%", marginTop: "-74px", width: "105px" }}
        />

        <h3 style={{ textAlign: "center" }}>Unlink Pluxee</h3>

        <p style={{ textAlign: "center" }}>
          Are you sure you want to unlink your Pluxee Wallet?
        </p>

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <button
            className="canclebtn"
            onClick={() => setSodexoUnlinkModal(false)}
          >
            No
          </button>

          <button
            className="deactivebtn"
            onClick={props.UnLinkLinkSodexo}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
)}

          <div
            style={{
              background:
                "radial-gradient(circle, rgba(245, 233, 233, 0.408) 0%, rgba(185, 245, 247, 0.34) 100%)",
              //"paddingBottom":Boolean((props.ActiveOrderItems[0])&&(props.ActiveOrderItemsListGlobal[0]))?"12.5rem":Boolean(props.ActiveOrderItems[0])?"9.5rem":props.ActiveOrderItemsListGlobal[0]&&"8.5rem",
            }}
            className=" pb-1 pt-1 overflow-y-auto h-screen"

          >
<div style={{padding:"5%",paddingTop:"100px"}}>
<OtherUpi/>

</div>
{!(route=="dphistory") ||!(route=="taghistory")&&<Typography
  sx={{
   
    ml: "15px",
    color: "#718198",
    fontFamily: "SF Pro Display",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
  }}
   style={{fontFamily:"roboto"}}
>
  Wallet
</Typography>}

<PaymentOptions/>

<Typography
  sx={{
    mt: "30px",
    ml: "15px",
    color: "#718198",
    fontFamily: "SF Pro Display",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "normal",
  }}
  style={{fontFamily:"roboto"}}
>
  Other Payment Method
</Typography>
<OtherPaymentOptions/>

      
          </div>
        </div>

      </div>
    </>
  );
}

export default PaymentOptions;
